import Component from '../core/Component'

const defaults = {
    target: null, // element id
    data: null // object
}

export default class FormFiller extends Component {
    constructor(element) {
        super(element, defaults)
    }

    prepare() {
        this.element.addEventListener('click', this.handleClick)
    }

    handleClick = event => {
        const target = document.getElementById(this.options.target)

        if (!target || !this.options.data) {
            return
        }

        Object.keys(this.options.data)
            .forEach(key => {
                const element = target.querySelector(`[data-name="${key}"]`)

                if (element) {
                    element.value = this.options.data[key]
                }
            })
    }
}
